import REQUEST from './Request';

export const getUnits = async (data) => {
  return await REQUEST({
    method: "GET",
    url: "unit/filter",
    params: data,
  });
};

export const getUnitById = async (unitId) => {
  return await REQUEST({
    method: "GET",
    url: `unit/${unitId}`,
  });
};

export const reserveUnit = async (data) => {
  return await REQUEST({
    method: "POST",
    url: "Reservation/reserve-unit",
    data: data,
  });
};

export const purchaseUnit = async (data) => {
  return await REQUEST({
    method: "POST",
    url: "Reservation/purchase-unit",
    data: data,
  });
}; 